import React from 'react';
import '../styles/CustomAlert.css';

const CustomAlert = ({ isOpen, type = 'info', title, message, onConfirm, onCancel, confirmText = '확인', cancelText = '취소' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'confirm': return '❓';
      default: return 'ℹ️';
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'success': return '#10b981';
      case 'error': return '#ef4444';
      case 'warning': return '#f59e0b';
      case 'confirm': return '#3b82f6';
      default: return '#6b7280';
    }
  };

  return (
    <div className="custom-alert-overlay" onClick={type === 'confirm' ? undefined : onConfirm}>
      <div className="custom-alert-content" onClick={(e) => e.stopPropagation()}>
        <div className="custom-alert-header">
          <div className="custom-alert-icon" style={{ color: getIconColor() }}>
            {getIcon()}
          </div>
          {title && <h3 className="custom-alert-title">{title}</h3>}
        </div>
        
        <div className="custom-alert-body">
          <p className="custom-alert-message">{message}</p>
        </div>

        <div className="custom-alert-footer">
          {type === 'confirm' ? (
            <>
              <button className="custom-alert-cancel-btn" onClick={onCancel}>
                {cancelText}
              </button>
              <button className="custom-alert-confirm-btn" onClick={onConfirm}>
                {confirmText}
              </button>
            </>
          ) : (
            <button className="custom-alert-confirm-btn" onClick={onConfirm}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert; 